import { IDownloadableContent } from "../../interfaces";
import { launcher } from ".";

const downloads: Array<IDownloadableContent> = [launcher];

export default downloads;
